import { useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';
import useReplaceQueryString from './useReplaceQueryString';

const useQueryStringTab = (tab: string) => {
  const [searchParams] = useSearchParams();
  const activeTab = Number(searchParams.get(tab)) || 0;
  const replaceQueryString = useReplaceQueryString();

  const onTabChange = useCallback(
    (index) => {
      replaceQueryString((query) => ({ ...query, [tab]: index }));
    },
    [replaceQueryString, tab]
  );

  return [activeTab, onTabChange];
};

export default useQueryStringTab;
